import * as React from 'react'
import DownloadIcon from '!svg-react-loader!images/igniter/svgs/download.svg'

interface IDownloadLink {
  text: string
  collection_id: number
  site_product_type_id: number
}

interface IProps {
  title?: string
  bucketContentsCount?: number
  link?: {
    text: string
    path: string
  }
  tagline?: string
  downloadLink?: IDownloadLink
}

const BucketHeader: React.FunctionComponent<IProps> = ({
  title = '',
  bucketContentsCount = 0,
  link,
  tagline = '',
  downloadLink,
}) => {
  let titleTag: React.ReactElement | string = title || ''
  let linkTag: React.ReactElement | string = ''
  let taglineTag: React.ReactElement | string = ''

  if (tagline) {
    taglineTag = <span className="tagline">{tagline}</span>
  } else if (bucketContentsCount > 0) {
    titleTag = (
      <>
        {titleTag}
        {' '}
        <span className="bucket-count hide-for-small-only">({bucketContentsCount.toLocaleString()})</span>
      </>
    )
  }

  if (link && link.path) {
    if (titleTag) {
      titleTag = <a href={link.path}>{titleTag}</a>
    }

    if (link.text) {
      linkTag = <a href={link.path}>{link.text}</a>
    }
  }

  return (
    <div className="grid-x grid-margin-x bucket-header align-middle">
      <div
        className="cell auto bucket-title"
        id={title.toLowerCase().replace(' ', '-')}
      >
        {titleTag}
        {taglineTag}
      </div>
      {downloadLink && (
        <div className="cell shrink text-right bucket-download-link show-for-medium">
          <button
            type="button"
            onClick={(e) => {
              e.preventDefault()
              document.dispatchEvent(new CustomEvent('bulk-download:open', {
                detail: {
                  collectionId: downloadLink.collection_id,
                  siteProductTypeId: downloadLink.site_product_type_id,
                },
              }))
            }}
          >
            {downloadLink.text}
            <DownloadIcon />
          </button>
        </div>
      )}
      <div className="cell shrink text-right bucket-link caret">{linkTag}</div>
    </div>
  )
}

export { BucketHeader }
